module.exports = __webpack_public_path__ + "static/img/yl@2x.f30ba36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/yl@2x.png
// module id = Av9N
// module chunks = 1